export default "__VITE_ASSET__C68FdFYD__"